import { userRoles } from "../../types/userRoles";

/**
 * Maps short names to enum values.
 */
const roleMapper: Record<string, string> = {
  supervisor: userRoles.supervisor,
  seeker: userRoles.seeker,
  operations: userRoles.operations,
  admin: userRoles.admin,
  external: userRoles.external,
  processor: userRoles.processor,
  brand: userRoles.brand,
  agency: userRoles.agency,
  executor: userRoles.executor,
  employer: userRoles.employer,
};

export function resolveUserRole(role: string): string {
  // If it's already an enum value, return as is
  if (Object.values(userRoles).includes(role as userRoles)) {
    return role;
  }

  // Extract last part after last dash
  const parts = role.trim().toLowerCase().split("-");
  const shortRole = parts[parts.length - 1];

  const mapped = roleMapper[shortRole];

  if (!mapped) {
    throw new Error(`Unknown role: ${role}`);
  }

  return mapped;
}

/**
 * Resolves enum key from its value.
 * E.g. "gogig-campaign-installer" => "installer"
 */
export function resolveUserRoleKey(roleValue: string): string {
  // Find the entry in the enum whose value matches
  const entry = Object.entries(userRoles).find(
    ([, value]) => value === roleValue
  );

  if (!entry) {
    throw new Error(`Unknown role value: ${roleValue}`);
  }

  const [key] = entry;
  return key;
}
